import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { supabase, isSupabaseConfigured } from "../lib/supabaseClient";

export default function MemberProfile() {
  const { session, profile, refreshProfile } = useAuth();
  const [fullName, setFullName] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    setFullName(profile?.full_name || "");
  }, [profile?.full_name]);

  const saveProfile = async (e) => {
    e.preventDefault();
    setMsg(null);
    if (!supabase || !session?.user?.id) return;
    const { error } = await supabase
      .from("profiles")
      .update({ full_name: fullName.trim() })
      .eq("id", session.user.id);
    if (error) {
      setMsg({ type: "danger", text: error.message });
      return;
    }
    await refreshProfile?.(session.user.id);
    setMsg({ type: "success", text: "Profile updated." });
  };

  const changePassword = async (e) => {
    e.preventDefault();
    setMsg(null);
    if (password.length < 6) {
      setMsg({ type: "danger", text: "Password must be at least 6 characters." });
      return;
    }
    if (password !== password2) {
      setMsg({ type: "danger", text: "Passwords do not match." });
      return;
    }
    if (!supabase) return;
    const { error } = await supabase.auth.updateUser({ password });
    if (error) {
      setMsg({ type: "danger", text: error.message });
      return;
    }
    setPassword("");
    setPassword2("");
    setMsg({ type: "success", text: "Password updated." });
  };

  if (!isSupabaseConfigured) {
    return <p className="text-danger">Supabase is not configured.</p>;
  }

  return (
    <div>
      <h1 className="h3 mb-3">Profile &amp; security</h1>
      <p className="text-muted small">
        Signed in as <strong>{session?.user?.email}</strong>
      </p>

      {msg && (
        <div className={`alert alert-${msg.type === "success" ? "success" : "danger"} small`}>
          {msg.text}
        </div>
      )}

      <div className="card border-0 shadow-sm mb-4">
        <div className="card-body">
          <h2 className="h5">Display name</h2>
          <form onSubmit={saveProfile} className="row g-2">
            <div className="col-md-8">
              <input
                className="form-control"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                placeholder="Full name"
              />
            </div>
            <div className="col-md-4">
              <button type="submit" className="btn btn_theme btn_md w-100">
                Save name
              </button>
            </div>
          </form>
          <p className="small text-muted mt-2 mb-0">
            To change your email, use Supabase Auth or contact support; profile email syncs from
            authentication.
          </p>
        </div>
      </div>

      <div className="card border-0 shadow-sm">
        <div className="card-body">
          <h2 className="h5">New password</h2>
          <form onSubmit={changePassword} className="row g-2">
            <div className="col-md-6">
              <input
                type="password"
                className="form-control"
                autoComplete="new-password"
                placeholder="New password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <div className="col-md-6">
              <input
                type="password"
                className="form-control"
                autoComplete="new-password"
                placeholder="Confirm password"
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
              />
            </div>
            <div className="col-12">
              <button type="submit" className="btn btn-outline-dark btn_md">
                Update password
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
